exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".currentSummary[data-v-44d21e0f]{display:inline-block;padding:1.25rem 1rem;width:1.5rem;border-left:1px solid #777;border-right:1px solid #777}@media (max-width:600px){.blockRow[data-v-44d21e0f]{padding:.25rem}.blockRow .block[data-v-44d21e0f]{height:1.5rem;width:1.5rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-44d21e0f&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/CurrentBlocks.vue
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-44d21e0f&scoped=true!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./dev/src/components/CurrentBlocks.vue
// module chunks = 0